import React from "react";
import { useParams } from "react-router-dom";
import { TRIP_PHASE } from "../../../utils/constants";
import "../css/EscortArrivalList.css";
import EscortArrivalActionButtons from "./EscortArrivalActionButtons";
import VehicleList from "./VehicleList";

const EscortArrivalList = ({ tripData, officers }) => {
  const { tripId } = useParams();

  const airportName = tripData?.arrivalAirport?.name;
  const arrivalVehicles = tripData?.escortVehicles?.filter(
    (vehicle) => vehicle.tripPhase === TRIP_PHASE.ARRIVAL
  );
  return (
    <div className="overlay">
      <div className="arrival-vehicle-list">
        <div className="arrival-vehicle-list-box">
          <VehicleList vehicles={arrivalVehicles} />
          {arrivalVehicles?.length > 0 && (
            <EscortArrivalActionButtons
              tripId={tripId}
              trackingId={tripData?.trackingId}
              officers={officers}
              clearanceStatus={tripData?.escortArrivalStatus}
              airportCodeOnApproved={tripData?.arrivalAirport}
              correctionReason={tripData?.escortArrivalCorrectionReason}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default EscortArrivalList;
